import { ConfirmationDialogProvider } from "@comps/ui/confirmation-dialog";
import { Toaster } from "@comps/ui/toaster";
import { Forbidden2, InfoCircle, Verify, Warning2 } from 'iconsax-react';
import ReactDOM from 'react-dom/client';
import Main from './Main';
import './i18n/i18n';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <>
    <ConfirmationDialogProvider>
      <Main />
      <Toaster 
        position="bottom-center"
        // closeButton={true}
        duration={5000}

        icons={{
          success: <Verify color='green' className='w-6 h-6' variant='Bold'/>,
          error: <Forbidden2 color='red' className='w-6 h-6' variant='Bold'/>,
          warning: <Warning2 color='yellow' className='w-6 h-6' variant='Bold'/>,
          info: <InfoCircle color='blue' className='w-6 h-6' variant='Bold'/>,
        }}
        toastOptions={{
          unstyled: true,
          classNames: {
            error: "bg-white text-black rounded-lg p-4 border-2 border-red-500 flex flex-row gap-4 items-center justify-between shadow-lg",
            success: "bg-white text-black rounded-lg p-4 border-2 border-green-500 flex flex-row gap-4 items-center justify-between shadow-lg",
            warning: "bg-white text-black rounded-lg p-4 border-2 border-yellow-500 flex flex-row gap-4 items-center justify-between shadow-lg",
            info: "bg-white text-black rounded-lg p-4 border-2 border-blue-500 flex flex-row gap-4 items-center justify-between shadow-lg",
          },

        }}
      />
    </ConfirmationDialogProvider>
  {/* </React.StrictMode> */}
  </>
);